import { CONSTANTS, decorators } from '@sohohouse/platform-resources'

const DateTime = decorators.shared.DateTime

export const RESULTS_PER_PAGE = 10

export const defaultFilters = {
  endsAt: {
    from: new DateTime().isoString
  }
}

export const previousFilters = {
  startsAt: {
    to: new DateTime().isoString,
    from: new DateTime(0).isoString
  }
}

export const filterStates = [
  CONSTANTS.EVENT_BOOKING_STATES.CONFIRMED,
  CONSTANTS.EVENT_BOOKING_STATES.WAITING,
  CONSTANTS.EVENT_BOOKING_STATES.UNCONFIRMED,
  CONSTANTS.EVENT_BOOKING_STATES.HELD
].join(',')

export const previousFilterStates = [
  CONSTANTS.EVENT_BOOKING_STATES.CONFIRMED,
  CONSTANTS.EVENT_BOOKING_STATES.CANCELLED
].join(',')
